module.exports = __webpack_public_path__ + "static/media/font_big.56ba230b.ico";